"use client";
import { makeStyles } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { ConstrainedContent } from "../components/layout/ConstrainedContent";
import { TabView, TabViewInfo } from "../components/TabView";
import ArchivedDocumentList from "../components/tool/ArchivedDocumentList";
import DraftDocumentList from "../components/tool/DraftDocumentList";
import PublishedDocumentList from "../components/tool/PublishedDocumentList";
import { useGetUserAccessLevel } from "../hooks/useGetUserAccessLevel";

const useClasses = makeStyles({
  root: {
    overflow: "visible",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
  },
});

const DocumentToolsPage = () => {
  const { t } = useTranslation();
  const classes = useClasses();

  const [searchParams] = useSearchParams();
  const view = searchParams.get("view") ?? "published";

  const accessLevel = useGetUserAccessLevel();

  const tabInfos: TabViewInfo[] = [
    { text: t("published"), value: "published" },
    { text: t("drafts"), value: "drafts" },
  ];

  if (accessLevel >= 3) {
    tabInfos.push({ text: t("archivedListTab"), value: "archived" });
  }

  return (
    <div className={classes.root}>
      <ConstrainedContent>
        <h1>{t("document")}</h1>
        <TabView
          tabInfos={tabInfos}
          defaultTabValue={view}
          onTabChange={() => undefined}
        />
      </ConstrainedContent>

      {view === "published" && <PublishedDocumentList />}

      {view === "drafts" && <DraftDocumentList />}

      {view === "archived" && accessLevel >= 3 && <ArchivedDocumentList />}
    </div>
  );
};

export default DocumentToolsPage;
